module.exports = __webpack_public_path__ + "static/media/stockhausen_mainz_5.d07cbc4b.jpg";